import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Shield } from 'lucide-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Props for the OwnerCellRenderer component
 */
interface OwnerCellRendererProps {
  /** Whether the user is an owner */
  value: boolean;
}

/**
 * Cell renderer for the "Owner" column in the user management table.
 * Displays a shield icon and "Yes" text for owners, or just "No" for non-owners.
 *
 * @param props - Component props
 * @returns Rendered cell content
 */
export const OwnerCellRenderer: FC<OwnerCellRendererProps> = ({ value }) => {
  const { t } = useTranslation('general');

  return value ? (
    <Stack alignItems="center" gap={1} orientation="horizontal">
      <Shield size={16} aria-hidden="true" />
      <Text as="span">{t('yes', { ns: 'general' })}</Text>
    </Stack>
  ) : (
    <Text as="span">{t('no', { ns: 'general' })}</Text>
  );
};
